<template>
  <div>
    <h1 class="title">
      <i class="iconhebei iconbaoming2"></i>
      志愿者活动
    </h1>
    <div class="volunteerActivity">
      <div
        v-for="(item, index) in list"
        :key="item.id"
        class="list"
        v-if="list"
      >
        <div class="activity_title">活动名称:{{ item.activity_name }}</div>
        <div class="page-volunteerActivity_bottom">
          <div class="name">姓名:{{ item.username }}</div>
          <div class="date">日期:{{ formatTime(item.ctime) || "" }}</div>
        </div>
      </div>
      <div v-show="list.length == 0" class="empty">
        空空如也~ 快去参加志愿活动吧~
      </div>
    </div>
  </div>
</template>

<script>
import card from "@components/OrderListCard.vue";
import util from "@util";
import { getVolunteerJointUrl } from "@url";
import axios from "axios";
export default {
  name: "volunteerActivity",
  components: {
    card,
  },
  data() {
    return {
      list: [],
    };
  },
  computed: {
    // 用户手机号
    userPhone() {
      return this.$store.state.userInfo.info.phone;
    },
  },
  mounted() {
    this.getVolunteerData();
  },
  methods: {
    formatTime(time) {
      return util.formatTime(new Date(time), "yyyy-MM-dd");
    },
    async getVolunteerData() {
      // 首次登陆无手机号 限制发送请求
      if (this.userPhone == "") {
        return this.$toast("请先绑定手机号！");
      }
      await axios
        .get(getVolunteerJointUrl, {
          params: { phone: this.userPhone },
        })
        .then(
          ({
            data: {
              data: { data, code },
            },
          }) => {
            if (code === 200) {
              this.list = data.data;
            }
          }
        );
    },
  },
};
</script>

<style lang="less" scoped>
.title {
  height: 46px;
  line-height: 46px;
  padding: 0 20px;
  color: #606060;
  font-size: 14px;
  font-weight: 500;
  .iconhebei {
    color: #5a9bf6;
  }
}
.volunteerActivity {
  .list {
    padding: 10px 20px;
    background-color: #eef9fa;
    margin-bottom: 20px;
    .activity_title {
      height: 40px;
      line-height: 40px;
      color: #ff8d09;
      border-bottom: 1px solid #eee;
    }
    .page-volunteerActivity_bottom {
      display: flex;
      height: 40px;
      line-height: 40px;
      justify-content: space-between;
    }
  }
  .empty {
    text-align: center;
    color: gray;
    margin-top: 40px;
    font-size: 14px;
  }
}
</style>